<h1 mat-dialog-title>Troubleshooting Perks</h1>
<mat-dialog-content>
    <span>
        @if (pending) {
            <div style="margin-bottom: 1rem;">
                Checking your Patreon and VRChat connections...<br>
                This might take a moment...
            </div>
            <div style="display: flex; justify-content: center; align-items: center; height: 100%;">
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
            </div>
        } @else {
            @if (isSuccess()) {
                <div>
                    We could not find any issues with your Patreon and VRChat connections.<br>
                    <ul>
                        @for (step of steps; track step.title) {
                            <li class="checklist-item">
                                @if (step.failure && step.correct) {    
                                    <app-icon icon="warning" [noMove]="true" [style.color]="'var(--mat-sys-primary)'"></app-icon>
                                } @else if (step.failure && !step.correct) {
                                    <app-icon icon="error" [noMove]="true" [style.color]="'var(--mat-sys-error)'"></app-icon>
                                } @else {
                                    <app-icon icon="check_circle" [noMove]="true" [style.color]="'var(--mat-sys-primary)'"></app-icon>
                                }
                                <div>
                                    <div class="list-head">
                                        <span>{{step.title}}</span>
                                    </div>
                                    <span>{{step.error ?? 'Success'}}</span>
                                </div>
                            </li>
                        }
                    </ul>
                </div>
            } @else {
                <div>
                    <b>We found some issues with your Patreon and VRChat connections.</b><br><br>
                    <ul class="checklist-list">
                        @for (step of failedSteps; track step.title) {
                            <li class="checklist-item">
                                @if (step.failure && step.correct) {
                                    <app-icon icon="check" [noMove]="true" [style.color]="'var(--mat-sys-primary)'"></app-icon>
                                } @else if (step.failure && !step.correct) {
                                    <app-icon icon="error" [noMove]="true" [style.color]="'var(--mat-sys-error)'"></app-icon>
                                } @else {
                                    <app-icon icon="check" [noMove]="true" [style.color]="'var(--mat-sys-primary)'"></app-icon>
                                }
                                <div>
                                    <div class="list-head">
                                        <span>{{step.title}}</span>
                                    </div>
                                    <span>{{step.error ?? 'Success'}}</span>
                                </div>
                            </li>
                        }
                    </ul>
                </div>
            }
        }
    </span>

</mat-dialog-content>